import { NexusRoutes } from './NexusRoutes';

export interface IdentityVerificationRoutes {
  latest: string;
  sync: (verificationId: string) => string;
}

export const portalIdentityVerificationRoutes: IdentityVerificationRoutes = {
  latest: NexusRoutes.IdentityVerification,
  sync: NexusRoutes.IdentityVerificationSync,
};

export const uniswapIdentityVerificationRoutes: IdentityVerificationRoutes = {
  latest: NexusRoutes.UniswapIdentityVerification,
  sync: NexusRoutes.UniswapIdentityVerificationSync,
};
